import {
    BoxProps,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerOverlay,
    Text,
    VStack,
    useMediaQuery,
    HStack
} from '@chakra-ui/react';
import {ReactNode} from 'react';
import {Structure} from '../../models';
import {DelegationContent, RequestContent, ResolutionContent} from "../RequestListing";

interface StructureDrawerProps {
    structure: Structure | null;
    isOpen: boolean;
    onClose: () => void;
}

type ContentProps = {title: string; children: ReactNode} & BoxProps;

export function StructureDrawer(p: StructureDrawerProps) {
  const [isLargeScreen] = useMediaQuery(`(min-width: 768px)`);
    function renderContent() {
        if (!p.structure) {
            return null;
        }
        switch (p.structure.type) {
            case "request": {
                const {data} = p.structure;
                return <Content title="Request Details">
                    <RequestContent
                        canCancel={data.canCancel}
                        chat={data.chat}
                        checkStatus={data.checkStatus}
                        currentEmail={data.currentEmail}
                        loading={data.isLoading}
                        onAction={data.onAction}
                        request={data.request}
                    />
                </Content>;
            }
            case "reassign": {
                const {data} = p.structure;
                return <Content title="Assign a new resolver">
                    <DelegationContent onClose={p.onClose} onAction={data.onAction}/>
                </Content>;
            }
            case "resolve": {
                const {data} = p.structure;
                return <Content title="Resolve Request">
                    <ResolutionContent onClose={p.onClose} onAction={data.onAction}/>
                </Content>;
            }
            default:
                return <Text>Unknown structure type.</Text>;
        }
    }
    return <Drawer
        isOpen={p.isOpen}
        placement={isLargeScreen ? "right": "bottom"}
        onClose={p.onClose}
        size="lg"
    >
        <DrawerOverlay />
        <DrawerContent h="100dvb" sx={{zIndex: "2000"}} isolation="isolate">
            <DrawerBody px={{base: "1rem", md: "2rem"}} py="1rem">
                {renderContent()}
            </DrawerBody>
        </DrawerContent>
    </Drawer>;
}

function Content(props: ContentProps) {
    return <VStack gap="1rem" align="stretch" h="full">
        <HStack justifyContent="space-between" position="relative">
            <Text
                color={props.color ?? "dark.500"}
                fontSize="18px"
                lineHeight="22px"
                fontWeight={500}
            >
                {props.title}
            </Text>
            <DrawerCloseButton
                insetY="0"
                insetInlineEnd="0"
                size="sm"
                fontSize="1rem"
                _hover={{background: "transparent"}}
            />
        </HStack>
        {props.children}
    </VStack>;
}
